'use client';

import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';
import ServiceContainer from './ServiceContainer';
import useLeadFormModalHook from './useLeadFormModalHook';
import LeadFormFields from './LeadFormFields';

const LeadFormModal = ({ isOpen, setIsOpen, isStudyAbroad }: any) => {
  const {
    handleClose,
    submitted,
    handleSubmit,
    handleInputChange,
    formData,
    setFormData,
    otpSent,
    setOtp,
    errorMessage,
    otp,
    title,
    showResend,
    resendOtp,
    timer,
    intakeYears,
    source,
    isAbroadCountry,
    handleToggleCourse,
    loading,
    modalFields,
  } = useLeadFormModalHook({ setIsOpen, isStudyAbroad });

  const [shouldDataFetch, setShouldDataFetch] = useState(false);


  useEffect(() => {
    if (isOpen) {
      document.body.classList.add('overflow-hidden');
    } else {
      document.body.classList.remove('overflow-hidden');
    }
    return () => {
      document.body.classList.remove('overflow-hidden');
    };
  }, [isOpen]);

  useEffect(() => {
    if (isOpen) {
      setShouldDataFetch(true);
    }
  }, [isOpen]);


  const collegeReviewTitle = source === 'college-review' ? `Review Now for ${title}!` : `Register Now for ${title}!`;

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[99999] bg-black bg-opacity-40 flex items-center justify-center">
      <div
        // className="bg-white w-full h-full lg:h-auto lg:w-[70rem] max-h-[95vh] rounded-md shadow-lg overflow-hidden relative"
        className="bg-white lg:max-w-screen-md lg:top-[50%] inset-y-0 top-[50%] w-full lg:min-w-[70rem] lg:min-h-80 h-full max-h-[48rem] lg:max-h-[38rem] outline-none shadow-lg drop-shadow "
      >
        {!submitted && (
          <div className="flex w-full h-full">
            <ServiceContainer />
            <div className="lg:basis-3/5 w-full h-full flex flex-col gap-x-4 px-4 lg:px-7 py-4 relative overflow-y-auto hide-scrollbar">
              <div className="lg:mt-5 font-poppins pr-12 lg:pr-16">
                <h2 className="font-bold text-lg lg:text-2xl text-primary leading-tight truncate max-w-full">
                  {title ? collegeReviewTitle : 'Register Now!'}
                </h2>
                <p className="text-secondary-gray text-xs lg:text-sm px-1 truncate">
                  Get Free Counselling & Regular Updates
                </p>
              </div>

              <button
                className="absolute right-3 top-4 lg:right-5 lg:top-5 cursor-pointer text-lg font-bold"
                onClick={handleClose}
              >
                <X className="size-5" />
              </button>

              {/* Lead Form Fields: */}
              <LeadFormFields
                formData={formData}
                setFormData={setFormData}
                modalFields={modalFields}
                intakeYears={intakeYears}
                otpSent={otpSent}
                isAbroadCountry={isAbroadCountry}
                isStudyAbroad={isStudyAbroad}
                handleInputChange={handleInputChange}
                handleToggleCourse={handleToggleCourse}
                source={source}
                shouldDataFetch={shouldDataFetch}
                handleSubmit={handleSubmit}
                otp={otp}
                setOtp={setOtp}
                loading={loading}
                showResend={showResend}
                resendOtp={resendOtp}
                timer={timer}
                handleClose={handleClose}
                errorMessage={errorMessage}
                />

            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default LeadFormModal;
